var render = function render(){
  var _vm$users, _vm$users$currentPage, _vm$users2, _vm$users3;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "addBtn"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.add-user-modal",
      modifiers: {
        "add-user-modal": true
      }
    }],
    staticClass: "mb-3",
    attrs: {
      "variant": "primary"
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "plus"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('admin.button.add-user')) + " ")], 1), _c('add-user-modal', {
    attrs: {
      "error": _vm.onClickError,
      "loading": _vm.addUserLoading
    },
    on: {
      "submit": _vm.onSubmit,
      "on-hidden": _vm.onHidden
    }
  })], 1), _c('div', {
    staticClass: "table-wrapper position-relative",
    attrs: {
      "aria-busy": _vm.loading ? 'true' : 'false'
    }
  }, [_c('b-table', {
    staticClass: "mb-0",
    attrs: {
      "id": "table",
      "items": (_vm$users = _vm.users) === null || _vm$users === void 0 ? void 0 : _vm$users.items,
      "per-page": _vm.pageSize,
      "fields": _vm.getTableFields,
      "responsive": "",
      "small": ""
    },
    scopedSlots: _vm._u([{
      key: "head(email)",
      fn: function (data) {
        return [_c('sortable-table-header', {
          attrs: {
            "label": data.label,
            "direction": _vm.getSortDirection('email')
          },
          on: {
            "sort": function ($event) {
              return _vm.changeSort('email');
            }
          }
        })];
      }
    }, {
      key: "head(fullName)",
      fn: function (data) {
        return [_c('sortable-table-header', {
          attrs: {
            "label": data.label,
            "direction": _vm.getSortDirection('fullName')
          },
          on: {
            "sort": function ($event) {
              return _vm.changeSort('fullName');
            }
          }
        })];
      }
    }, {
      key: "head(phone)",
      fn: function (data) {
        return [_c('sortable-table-header', {
          attrs: {
            "label": data.label,
            "direction": _vm.getSortDirection('phone')
          },
          on: {
            "sort": function ($event) {
              return _vm.changeSort('phone');
            }
          }
        })];
      }
    }, {
      key: "head(package)",
      fn: function (data) {
        return [_c('sortable-table-header', {
          attrs: {
            "label": data.label,
            "direction": _vm.getSortDirection('package')
          },
          on: {
            "sort": function ($event) {
              return _vm.changeSort('package');
            }
          }
        })];
      }
    }, {
      key: "head(chatbotTokenLimitMonthly)",
      fn: function (data) {
        return [_c('sortable-table-header', {
          attrs: {
            "label": data.label,
            "direction": _vm.getSortDirection('chatbotTokenLimitMonthly')
          },
          on: {
            "sort": function ($event) {
              return _vm.changeSort('chatbotTokenLimitMonthly');
            }
          }
        })];
      }
    }, {
      key: "head(chatbotTokensUsedMonthly)",
      fn: function (data) {
        return [_c('sortable-table-header', {
          attrs: {
            "label": data.label,
            "direction": _vm.getSortDirection('chatbotTokensUsedMonthly')
          },
          on: {
            "sort": function ($event) {
              return _vm.changeSort('chatbotTokensUsedMonthly');
            }
          }
        })];
      }
    }, {
      key: "head(actions)",
      fn: function (data) {
        return [_c('sortable-table-header', {
          attrs: {
            "label": data.label,
            "direction": _vm.getSortDirection('chatbotEnabled')
          },
          on: {
            "sort": function ($event) {
              return _vm.changeSort('chatbotEnabled');
            }
          }
        })];
      }
    }, {
      key: "cell(email)",
      fn: function (row) {
        return [_c('div', {
          staticClass: "email"
        }, [_vm._v(" " + _vm._s(row.item.email) + " "), row.item.role === 'ADMIN' ? _c('img', {
          staticClass: "mb-1",
          attrs: {
            "src": require("@/assets/customer-project/administrator.svg")
          }
        }) : _vm._e()])];
      }
    }, {
      key: "cell(package)",
      fn: function (row) {
        return [row.item.projectPackage ? _c('span', [_vm._v(" " + _vm._s(_vm.$t(`package.type.${row.item.projectPackage}`)) + " "), _c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !row.detailsShowing,
            expression: "!row.detailsShowing"
          }, {
            name: "b-toggle",
            rawName: "v-b-toggle",
            value: 'collapse' + row.item.id,
            expression: "'collapse' + row.item.id"
          }],
          attrs: {
            "id": row.item.id,
            "src": require("@/assets/event-flow-table/arrow_down.svg")
          },
          on: {
            "click": row.toggleDetails
          }
        }), _c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: row.detailsShowing,
            expression: "row.detailsShowing"
          }, {
            name: "b-toggle",
            rawName: "v-b-toggle",
            value: 'collapse' + row.item.id,
            expression: "'collapse' + row.item.id"
          }],
          attrs: {
            "id": row.item.id,
            "src": require("@/assets/event-flow-table/arrow_up.svg")
          },
          on: {
            "click": row.toggleDetails
          }
        })]) : _c('span', [_vm._v("-")])];
      }
    }, {
      key: "cell(chatbotTokenLimitMonthly)",
      fn: function (row) {
        var _row$item$chatbotToke;
        return [_vm._v(" " + _vm._s((_row$item$chatbotToke = row.item.chatbotTokenLimitMonthly) !== null && _row$item$chatbotToke !== void 0 ? _row$item$chatbotToke : 0) + " ")];
      }
    }, {
      key: "cell(chatbotTokensUsedMonthly)",
      fn: function (row) {
        var _row$item$chatbotToke2;
        return [_vm._v(" " + _vm._s((_row$item$chatbotToke2 = row.item.chatbotTokensUsedMonthly) !== null && _row$item$chatbotToke2 !== void 0 ? _row$item$chatbotToke2 : 0) + " ")];
      }
    }, {
      key: "cell(actions)",
      fn: function (row) {
        return [_c('img', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal",
            value: 'update-user-modal' + row.item.id,
            expression: "'update-user-modal' + row.item.id"
          }, {
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.top",
            modifiers: {
              "hover": true,
              "top": true
            }
          }],
          staticClass: "div-button",
          attrs: {
            "id": row.item.id,
            "title": _vm.$t('admin.button.edit'),
            "src": require("@/assets/master-data/pen.svg")
          },
          on: {
            "click": function ($event) {
              return _vm.resetUpdateProfileForm(row.item.id);
            }
          }
        }), _vm.isChatbotQuotaEnabled ? _c('b-form-checkbox', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.top",
            modifiers: {
              "hover": true,
              "top": true
            }
          }],
          staticClass: "chatbot-toggle",
          attrs: {
            "id": `chatbot-toggle-${row.item.id}`,
            "checked": _vm.isUserChatbotEnabled(row.item),
            "disabled": _vm.isChatbotToggleLoading(row.item.id),
            "switch": "",
            "title": _vm.$t('admin.field.chatbot-toggle-tooltip'),
            "value": true,
            "unchecked-value": false
          },
          on: {
            "change": function ($event) {
              return _vm.onToggleChatbot(row.item, $event);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.isUserChatbotEnabled(row.item) ? _vm.$t('admin.field.chatbot-on') : _vm.$t('admin.field.chatbot-off')) + " ")]) : _vm._e(), _c('custom-modal', {
          attrs: {
            "id": 'update-user-modal' + row.item.id
          },
          on: {
            "on-hidden": function ($event) {
              return _vm.resetUpdateProfileForm(row.item.id);
            }
          },
          scopedSlots: _vm._u([{
            key: "body",
            fn: function () {
              return [_c('b-overlay', {
                staticClass: "col-md-12",
                attrs: {
                  "opacity": "0",
                  "show": _vm.updateLoading,
                  "spinner-variant": "primary",
                  "spinner-type": "grow"
                }
              }, [_c('img', {
                staticClass: "modal-icon",
                attrs: {
                  "src": require("@/assets/customer-project/invite-icon.svg")
                }
              }), _c('profile-form', {
                key: _vm.getUpdateProfileFormKey(row.item.id),
                staticClass: "mb-4",
                attrs: {
                  "profile-response": row.item,
                  "show-chatbot-quota-fields": _vm.isChatbotQuotaEnabled,
                  "error": _vm.onClickError
                },
                on: {
                  "submit": function ($event) {
                    return _vm.onSubmitProfile($event, row.item.id);
                  }
                }
              }), _c('password-form', {
                attrs: {
                  "is-admin": "",
                  "error": _vm.passwordError
                },
                on: {
                  "submit": function ($event) {
                    return _vm.onSubmitPassword($event, row.item.id);
                  }
                }
              })], 1)];
            },
            proxy: true
          }], null, true)
        }), _vm.canDeactivateUser(row.item) ? _c('div', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal",
            value: `deactivate-modal${row.item.id}`,
            expression: "`deactivate-modal${row.item.id}`"
          }, {
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.top",
            modifiers: {
              "hover": true,
              "top": true
            }
          }],
          staticClass: "div-button",
          attrs: {
            "id": `btn${row.item.id}`,
            "title": _vm.$t('admin.button.deactivate')
          }
        }, [_c('img', {
          attrs: {
            "src": require("@/assets/admin/deactivate.svg")
          }
        })]) : !row.item.active ? _c('div', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal",
            value: `reactivate-modal${row.item.id}`,
            expression: "`reactivate-modal${row.item.id}`"
          }, {
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.top",
            modifiers: {
              "hover": true,
              "top": true
            }
          }],
          staticClass: "div-button",
          attrs: {
            "id": `btn${row.item.id}`,
            "title": _vm.$t('admin.button.activate')
          }
        }, [_c('img', {
          attrs: {
            "src": require("@/assets/admin/reactivate.svg")
          }
        })]) : _vm._e(), _c('confirmation-modal', {
          attrs: {
            "id": `deactivate-modal${row.item.id}`,
            "variant": "danger",
            "yes-key": "customer-project.modal.deactivate.ok"
          },
          on: {
            "on-click-yes": function ($event) {
              return _vm.softDeleteOnClick(row.item.id);
            }
          },
          scopedSlots: _vm._u([{
            key: "body-text",
            fn: function () {
              return [_c('img', {
                staticClass: "modal-icon",
                attrs: {
                  "src": require("@/assets/customer-project/danger.svg")
                }
              }), _c('h2', {
                staticClass: "modal-title"
              }, [_vm._v(" " + _vm._s(_vm.$t('admin.modal.deactivate.title')) + " ")]), _c('p', {
                staticClass: "modal-p"
              }, [_vm._v(" " + _vm._s(_vm.$t('admin.modal.deactivate.body')) + " "), _c('strong', [_vm._v(" " + _vm._s(`${row.item.firstName} ${row.item.lastName}`) + " ")])])];
            },
            proxy: true
          }], null, true)
        }), _c('confirmation-modal', {
          attrs: {
            "id": `reactivate-modal${row.item.id}`,
            "yes-key": "customer-project.modal.reactivate.ok"
          },
          on: {
            "on-click-yes": function ($event) {
              return _vm.reactivateOnClick(row.item.id);
            }
          },
          scopedSlots: _vm._u([{
            key: "body-text",
            fn: function () {
              return [_c('img', {
                staticClass: "modal-icon",
                attrs: {
                  "src": require("@/assets/customer-project/danger.svg")
                }
              }), _c('h2', {
                staticClass: "modal-title"
              }, [_vm._v(" " + _vm._s(_vm.$t('admin.modal.reactivate.title')) + " ")]), _c('p', {
                staticClass: "modal-p"
              }, [_vm._v(" " + _vm._s(_vm.$t('admin.modal.reactivate.body')) + " "), _c('strong', [_vm._v(" " + _vm._s(`${row.item.firstName} ${row.item.lastName}`) + " ")])])];
            },
            proxy: true
          }], null, true)
        }), !_vm.getDisabledState(row.item.role, row.item.email) ? _c('div', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal",
            value: `delete-modal${row.item.id}`,
            expression: "`delete-modal${row.item.id}`"
          }, {
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.top",
            modifiers: {
              "hover": true,
              "top": true
            }
          }],
          staticClass: "div-button",
          attrs: {
            "title": _vm.$t('admin.button.delete')
          }
        }, [_c('img', {
          attrs: {
            "src": require("@/assets/master-data/trash.svg")
          }
        })]) : _vm._e(), _c('confirmation-modal', {
          attrs: {
            "id": `delete-modal${row.item.id}`,
            "variant": "danger",
            "yes-key": "delete"
          },
          on: {
            "on-click-yes": function ($event) {
              return _vm.hardDeleteOnClick(row.item.id);
            }
          },
          scopedSlots: _vm._u([{
            key: "body-text",
            fn: function () {
              return [_c('img', {
                staticClass: "modal-icon",
                attrs: {
                  "src": require("@/assets/customer-project/danger.svg")
                }
              }), _c('h2', {
                staticClass: "modal-title"
              }, [_vm._v(" " + _vm._s(_vm.$t('admin.modal.delete.title')) + " ")]), _c('p', {
                staticClass: "modal-p"
              }, [_vm._v(" " + _vm._s(_vm.$t('admin.modal.delete.body')) + " "), _c('strong', [_vm._v(" " + _vm._s(`${row.item.firstName} ${row.item.lastName}`) + " ")])])];
            },
            proxy: true
          }], null, true)
        })];
      }
    }, {
      key: "row-details",
      fn: function (row) {
        var _row$item, _row$item$packageHist, _row$item2;
        return [_c('b-overlay', {
          staticClass: "w-100 h-100",
          attrs: {
            "show": _vm.historyLoading,
            "spinner-variant": "primary",
            "spinner-type": "grow"
          }
        }, [_c('b-collapse', {
          staticClass: "mt-2",
          attrs: {
            "id": 'collapse' + row.item.id
          },
          on: {
            "show": function ($event) {
              return _vm.fetchPackageHistory(row.item.projectId);
            }
          }
        }, [!((_row$item = row.item) !== null && _row$item !== void 0 && (_row$item$packageHist = _row$item.packageHistory) !== null && _row$item$packageHist !== void 0 && _row$item$packageHist.length) ? _c('p', [_vm._v(" " + _vm._s(_vm.$t('admin.empty')) + " ")]) : _c('div', {
          staticClass: "table-wrapper"
        }, [_c('b-table', {
          staticClass: "mb-0",
          attrs: {
            "responsive": "",
            "small": "",
            "fields": _vm.getHistoryFields,
            "items": (_row$item2 = row.item) === null || _row$item2 === void 0 ? void 0 : _row$item2.packageHistory
          },
          scopedSlots: _vm._u([{
            key: "cell(packageType)",
            fn: function (historyRow) {
              return [_vm._v(" " + _vm._s(_vm.$t(`package.type.${historyRow.item.packageType}`)) + " ")];
            }
          }, {
            key: "cell(startedAt)",
            fn: function (historyRow) {
              return [_vm._v(" " + _vm._s(new Date(historyRow.item.startedAt).toLocaleString()) + " ")];
            }
          }, {
            key: "cell(endedAt)",
            fn: function (historyRow) {
              return [_vm._v(" " + _vm._s(_vm.formatPackageHistoryEndDate(historyRow.item.endedAt)) + " ")];
            }
          }], null, true)
        })], 1)])], 1)];
      }
    }])
  }), _c('b-overlay', {
    attrs: {
      "show": _vm.loading,
      "spinner-variant": "primary",
      "spinner-type": "grow",
      "opacity": "0.65",
      "rounded": "sm",
      "no-wrap": ""
    }
  })], 1), _c('b-pagination', {
    staticClass: "ml-3",
    attrs: {
      "value": ((_vm$users$currentPage = (_vm$users2 = _vm.users) === null || _vm$users2 === void 0 ? void 0 : _vm$users2.currentPage) !== null && _vm$users$currentPage !== void 0 ? _vm$users$currentPage : 0) + 1,
      "total-rows": (_vm$users3 = _vm.users) === null || _vm$users3 === void 0 ? void 0 : _vm$users3.totalItems,
      "per-page": _vm.pageSize,
      "aria-controls": "table",
      "align": "right",
      "limit": "5",
      "hide-goto-end-buttons": ""
    },
    on: {
      "change": function ($event) {
        return _vm.loadUsers($event - 1);
      }
    }
  }, [_c('template', {
    slot: "prev-text"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("@/assets/customer-project/prev.svg")
    }
  }), _vm._v(" " + _vm._s(_vm.$t('prev')) + " ")]), _c('template', {
    slot: "next-text"
  }, [_vm._v(" " + _vm._s(_vm.$t('next')) + " "), _c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("@/assets/customer-project/next.svg")
    }
  })])], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }